import Component from './survey-state-filter-container';

export default Component;
